module.exports = __webpack_public_path__ + "img/icon_primary_menu_money@2x.175547ac.png";